CustomTC.define('jquery/var/pnum',[],function() {
	return (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
});

